import React, { useState, useRef } from "react"
import { Container } from "react-bootstrap"
import { Map, Marker } from "pigeon-maps"

import {
  Box,
  Grid,
  Slider,
  Typography,
} from "@mui/material"

import InfoCard from "./Card.js"

import * as styles from "./Map.module.scss"

import typeMapping from "../../data/type_mapping.json"

const selectedMarkerColor = "#eee"
const singaporeCoordinates = [1.3521, 103.8198]
const oldestYear = 1820
const currentYear = new Date().getFullYear()



const MapComponent = ({ location, data : originalData }) => {
	const legendsCode = Object.keys(typeMapping)
	const legends = legendsCode.map(key => ({ key, ...typeMapping[key] }))

  // React State
	const [selectedYearRange, setSelectedYearRange] = useState([oldestYear, currentYear])
	const [filterType, setFilterType] = useState(Object.fromEntries(legendsCode.map(loc => [loc, true])))
	const [selectedPlace, setSelectedPlace] = useState(null)
	const mapContainerRef = useRef(null)

	function handleChangeYear(event, yearRange) {
	// Prevent updates for non-effective slide action
		if (yearRange === selectedYearRange) return

		setSelectedYearRange(yearRange)
	}

	function handleFilterType(type) {
		setSelectedPlace(null)
		setFilterType({ ...filterType, [type]: !filterType[type] })
	}

	function allPlacesData() {
		return originalData
				.filter(place => filterType[place.type])
				.filter(({ established_year }) => {
					return established_year === null
					|| (established_year >= selectedYearRange[0] && established_year <= selectedYearRange[1])
				})
	}

	// Handle location state from index pages
	if (location.state) {
		const [ target ] = originalData.filter(data => data.id === location.state.id);

		location.state = null;
		setSelectedPlace(target);
	}

	return (
		<Container className={styles.mapContainer}>

		<section ref={mapContainerRef}>
			<InfoCard
				data={selectedPlace}
				setData={setSelectedPlace}
				enabled={!!selectedPlace}
				container={mapContainerRef.current}
			/>

			<Map
				height={600}
				defaultWidth={800}
				defaultCenter={selectedPlace
						? [selectedPlace.latitude, selectedPlace.longitude]
						: singaporeCoordinates}
				defaultZoom={selectedPlace ? 18 : 12}
				metaWheelZoom={true}
			>
				{allPlacesData().map(data => {
					const { id, latitude, longitude, type } = data
					return (
						<Marker
							key={id}
							width={selectedPlace?.id === id ? 42 : 40}
							anchor={[latitude, longitude]}
							color={
								(({ id : selectedId = null }) =>
									selectedId === id
										? selectedMarkerColor
										: typeMapping[type].color
								)(selectedPlace || {})
							}
							onClick={() => setSelectedPlace(data)}
						/>
					)
				})}
			</Map>			
		</section>

		<Box
			className={styles.legends}
		>

			{legends.map(legend =>
				<span
					role="button"
					tabIndex="0"
					key={legend.name}
					style={{ cursor: "pointer", outline: "none", opacity: filterType[legend.key] ? 1 : 0.3 }}
					onClick={() => handleFilterType(legend.key)}
					onKeyPress={() => {}}
				>
					<span className={styles.colorBox} style={{ backgroundColor: legend.color }}></span>
					{legend.name}
				</span>
			)}

		</Box>



		<Grid
			container
			alignItems="center"
			columnSpacing={5}
			my={1}
			px={3}
		>
			<Grid item>
				<Typography variant="subtitle1">
					Year: {selectedYearRange.join(" - ")}
				</Typography>
			</Grid>

			<Grid item xs>
				<Slider
					min={oldestYear}
					max={currentYear}
					value={selectedYearRange}
					onChange={handleChangeYear}
					step={5}
					marks
					aria-labelledby="discrete-slider-custom"
					getAriaLabel={() => "Establishment Year Range"}
					getAriaValueText={value => value}
					valueLabelDisplay="auto"
				/>
			</Grid>
		</Grid>

		</Container>
  )
}

export default MapComponent
